import { action, observable, makeObservable } from 'mobx';

export enum SubmissionType {
    SP = 'SP',
    FP = 'FP'
}

export type AvSubmissionType = {
    id: string;
    data: AvSubmissionDataType;
    status: string;
    type: string;
    result?: AvSubmissionResultType;
};

export type AvSubmissionDataType = {
    submissionType: SubmissionType;
    name: string;
    email: string;
    status: string;
    comment?: string;
    confidential?: boolean;
    priority?: number;
    files?: File[];
    urlEntries?: URL[];
    fileUploadStatus?: Record<string, string>;
};

export type AvSubmissionResultType = {
    files: AvSubmissionFileResultType[];
    urls: AvSubmissionUrlResultType[];
};

export type AvSubmissionFileResultType = {
    sha256: string;
    name: string;
    size: number;
    mime: string;
    status: string;
    detection: string;
    rescan: string;
    lastscan: string;
    detectionCategory: string;
};

export type AvSubmissionUrlResultType = {
    URL: string;
    status: string;
    detection: string;
    rescan: string;
    lastscan: string;
};

export default class AvStore {
    avSubmission: AvSubmissionType = {
        id: '',
        data: {
            submissionType: SubmissionType.SP,
            name: '',
            email: '',
            status: ''
        },
        status: '',
        type: '',
        result: [
            {
                sha256: '',
                name: '',
                size: 0,
                mime: '',
                status: '',
                detection: '',
                rescan: '',
                lastscan: '',
                detectionCategory: ''
            }
        ]
    };

    constructor(avSubmission: AvSubmissionType) {
        this.update(avSubmission);

        makeObservable(this, {
            avSubmission: observable,
            update: action
        });
    }

    update(avSubmission: AvSubmissionType): void {
        this.avSubmission = {
            ...this.avSubmission,
            ...avSubmission
        };
    }
}
